module.exports = __webpack_public_path__ + "img/07_colegas-dando-golpe-puno.56ef53ad.jpg";